function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { stringify } from 'utils/query-string';
import { HttpClient } from 'api/http-client';
const BASE_URL = '/revenue-entries';
class RevenueEntriesApiClient extends HttpClient {
    constructor(...args){
        super(...args), /**
   * Get revenue entry by ID with full details
   */ _define_property(this, "getRevenueEntryById", (revenueEntryId)=>{
            return this.get(`${BASE_URL}/${revenueEntryId}`);
        }), /**
   * Get list of revenue entries with filters
   */ _define_property(this, "getRevenueEntries", (params = {})=>{
            const queryString = stringify(params, {
                skipNull: true
            });
            const url = queryString ? `${BASE_URL}?${queryString}` : BASE_URL;
            return this.get(url);
        }), /**
   * Create a new revenue entry
   */ _define_property(this, "createRevenueEntry", (data)=>{
            return this.post(BASE_URL, data);
        }), /**
   * Update an existing revenue entry
   */ _define_property(this, "updateRevenueEntry", (revenueEntryId, data)=>{
            return this.put(`${BASE_URL}/${revenueEntryId}`, data);
        }), /**
   * Delete a revenue entry (soft delete)
   */ _define_property(this, "deleteRevenueEntry", (revenueEntryId, context)=>{
            const queryString = context ? `?${stringify(context, {
                skipNull: true
            })}` : '';
            const url = `${BASE_URL}/${revenueEntryId}${queryString}`;
            return this.delete(url);
        }), /**
   * Get revenue summary with filters
   */ _define_property(this, "getRevenueSummary", (params = {})=>{
            const queryString = stringify(params, {
                skipNull: true
            });
            const url = queryString ? `${BASE_URL}/summary?${queryString}` : `${BASE_URL}/summary`;
            return this.get(url);
        }), /**
   * Get list of accessible project IDs for revenue entries
   */ _define_property(this, "getAccessibleProjects", (action)=>{
            return this.get(`${BASE_URL}/project-access?action=${action}`);
        }), /**
   * Get access flags order/mapping (bit positions) for revenue entries
   */ _define_property(this, "getRevenueEntryAccessFlagsOrder", ()=>{
            return this.get(`${BASE_URL}/access-flags`);
        }), /**
   * Get revenue entry access for account or a specific project
   */ _define_property(this, "getRevenueEntryAccess", async (projectId)=>{
            const query = projectId ? `?projectId=${projectId}` : '';
            return this.get(`${BASE_URL}/access${query}`);
        }), /**
   * Get audit logs for a revenue entry
   */ _define_property(this, "getRevenueEntryAuditLogs", (revenueEntryId)=>{
            return this.get(`${BASE_URL}/${revenueEntryId}/audit-logs`);
        }), /**
   * Get missing date ranges for revenue entries
   * Returns date ranges where revenue entries can be created without overlapping
   */ _define_property(this, "getMissingDateRanges", (params)=>{
            const queryString = stringify(params, {
                skipNull: true
            });
            const url = queryString ? `${BASE_URL}/missing-dates?${queryString}` : `${BASE_URL}/missing-dates`;
            return this.get(url);
        }), /**
   * Get revenue update summary showing impact of edit/delete action
   * Returns period-wise breakdown of revenue changes
   */ _define_property(this, "getRevenueUpdateSummary", (request, params)=>{
            const queryString = params ? stringify(params, {
                skipNull: true
            }) : '';
            const url = queryString ? `${BASE_URL}/update-summary?${queryString}` : `${BASE_URL}/update-summary`;
            return this.post(url, request);
        }), /**
   * Verify whether the selected posting period can be locked.
   * Returns list of projects and their missing periods if gaps exist.
   */ _define_property(this, "verifyPeriodLock", (request)=>{
            return this.post(`${BASE_URL}/period-lock-verification`, request);
        }), /**
   * Get allowed posting periods for creating revenue entries for a project/budget
   */ _define_property(this, "getAllowedRevenuePeriods", (projectId, budgetId)=>{
            return this.get(`${BASE_URL}/project/${projectId}/allowed-periods`, {
                params: {
                    budgetId
                }
            });
        });
    }
}
export const RevenueEntriesApi = new RevenueEntriesApiClient();
